

const ToggleComponent = ({ isVisible, children }) => {
    return <div className={isVisible ? "htFlex1 f-column" : "htHide"}>
        {children}
    </div>
}

export default ToggleComponent;